import axios from 'axios';

export const getCategories = async () => {
    const apiUrl = `${process.env.REACT_APP_PUBLIC_API}/categories?parent=1&order[sort]=asc`;

    return axios.get(apiUrl).then((resp) => resp.data);
}

